export default {
  ADMIN: 'System Administrator',
  ROUTE: 'Route Staff',
  ROUTE_MANAGER: 'Route Manager',
  LINE_OPERATION: 'Line Operation',
  LINE_MANAGER: 'Line Manager',
  CUSTOMER_SERVICE: 'Customer Service',
  SERVICE: 'Customer Service',
  SERVICE_MANAGER: 'CS Manager',
  SALES: 'Sales',
  SALES_MANAGER: 'Sales Manager',
  FINANCE: 'Finance',
  MANAGEMENT: 'Management',
  DISPATCHER: 'Dispatcher',
  CS: 'CS',
  OPS: 'OPS',
  SYSTEM: 'System',
}
